import type { ReactNode } from 'react'

interface SectionProps {
  id: string
  title: string
  note?: string
  children: ReactNode
}

// Shared editorial layout: section title in the left rail, content on the right
const Section = ({ id, title, note, children }: SectionProps) => (
  <section id={id} className="border-t border-rule">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16 md:py-24 grid md:grid-cols-12 gap-x-10 gap-y-8">
      <div className="md:col-span-3">
        <div className="md:sticky md:top-28">
          <h2 className="font-serif text-3xl md:text-4xl font-medium tracking-tight">{title}</h2>
          {note && <p className="mt-3 text-sm leading-relaxed text-mute max-w-[16rem]">{note}</p>}
        </div>
      </div>
      <div className="md:col-span-9 min-w-0">{children}</div>
    </div>
  </section>
)

export default Section
